import { TypedDocumentNode, gql } from '@apollo/client';
import { useState } from 'react';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';

import { LeagueTrckSlotCta } from '../LeagueTrckSlotCta';
import { LeagueTrckSlots } from '../LeagueTrckSlots';
import { getLeagueTrackSlotsInfo } from '../utils';
import type { LeagueTrckSlotsPicker_so5LeagueTrack } from './__generated__/index.graphql';

const Buttons = styled(Horizontal)`
  width: 100%;
  padding: 0 var(--double-unit);
  > * {
    flex: 1;
  }
`;

type Props = {
  so5LeagueTrack: LeagueTrckSlotsPicker_so5LeagueTrack;
};

export const LeagueTrckSlotsPicker = ({ so5LeagueTrack }: Props) => {
  const { firstNotComposedSlot } = getLeagueTrackSlotsInfo(so5LeagueTrack);

  const [selectedIndex, setSelectedIndex] =
    useState<number>(firstNotComposedSlot);

  return (
    <>
      <LeagueTrckSlots
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
        so5LeagueTrack={so5LeagueTrack}
      />
      <Buttons>
        <LeagueTrckSlotCta
          selectedIndex={selectedIndex}
          so5LeagueTrack={so5LeagueTrack}
        />
      </Buttons>
    </>
  );
};

LeagueTrckSlotsPicker.fragments = {
  so5LeagueTrack: gql`
    fragment LeagueTrckSlotsPicker_so5LeagueTrack on So5LeagueTrack {
      slug
      ...LeagueTrckSlots_so5LeagueTrack
      ...LeagueTrckSlotCta_so5LeagueTrack
    }
    ${LeagueTrckSlots.fragments.so5LeagueTrack}
    ${LeagueTrckSlotCta.fragments.so5LeagueTrack}
    ${getLeagueTrackSlotsInfo.fragments.so5LeagueTrack}
  ` as TypedDocumentNode<LeagueTrckSlotsPicker_so5LeagueTrack>,
};
